export enum PersonContactStatusEnum {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}

export enum PersonContactStatusLabelEnum {
    IN_PROGRESS = 'Aguardando',
    COMPLETED = 'Concluída',
}
